"use client";
import { useLayoutEffect, useState } from "react";

export function useIsPando() {
  const [isPando, setIsPando] = useState<boolean | null>(null);

  useLayoutEffect(() => {
    const domain = window.location.hostname || "";
    setIsPando(domain.includes("pando"));
  }, []);

  return isPando;
}
